'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Input, InputDecorator } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgRefresh } from '@common/icon';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthMutation, AuthQueryKey } from '@/api';
import { ROUTES } from '@/constants';
import { useLogout } from '@/hooks/useLogout';
import { MAX_NICKNAME_LENGTH, useUserInfoForm } from '@/hooks/useUserInfoForm';
import { useAuthStore } from '@/stores/AuthStore';
import { ProfileImageEdit } from '../../../(private)/my/edit/_components/ProfileImageEdit';
export const ProfilePopoverContent = t0 => {
  const $ = _c(78);
  const {
    onClose
  } = t0;
  const myInfo = useAuthStore(_temp);
  const {
    form,
    refetchNickname
  } = useUserInfoForm();
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  const {
    logout
  } = useLogout();
  const {
    handleSubmit,
    register,
    watch,
    getValues,
    setValue,
    formState: t1
  } = form;
  const {
    errors
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = AuthMutation["put:/wello/v2/auth/member/profile"]();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onClose || $[2] !== queryClient || $[3] !== toast) {
    t3 = async () => {
      await queryClient.invalidateQueries({
        queryKey: AuthQueryKey["get:/wello/v2/auth/member/profile"]()
      });
      toast({
        message: "\uB0B4 \uC815\uBCF4\uB97C \uC218\uC815\uD588\uC5B4\uC694"
      });
      onClose();
    };
    $[1] = onClose;
    $[2] = queryClient;
    $[3] = toast;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== toastError) {
    t4 = error => {
      toastError({
        error
      });
    };
    $[5] = toastError;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      ...t2,
      onSuccess: t3,
      onError: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    mutate: putProfileMutate,
    isPending
  } = useMutation(t5);
  if (!myInfo) {
    return null;
  }
  let t6;
  if ($[10] !== myInfo.profileImage) {
    t6 = <div className="flex justify-center"><ProfileImageEdit imageSrc={myInfo.profileImage} /></div>;
    $[10] = myInfo.profileImage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = errors.nickname?.message;
  let t8;
  if ($[12] !== register) {
    t8 = register("nickname");
    $[12] = register;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== refetchNickname) {
    t9 = () => refetchNickname();
    $[14] = refetchNickname;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SvgRefresh className="size-20" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t9) {
    t11 = <Button className="size-fit p-0 pt-2 text-Gray-700" theme="sub-text" type="button" onClick={t9}>{t10}</Button>;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t8) {
    t12 = <Input {...t8} maxLength={MAX_NICKNAME_LENGTH} placeholder={"\uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694"} rightContent={t11} />;
    $[19] = t11;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t7) {
    t13 = <InputDecorator label={"\uB2C9\uB124\uC784"} validationMessage={t7}>{t12}</InputDecorator>;
    $[22] = t12;
    $[23] = t7;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = errors.email?.message;
  let t15;
  if ($[25] !== register) {
    t15 = register("email");
    $[25] = register;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <Input {...t15} disabled={true} placeholder={"\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694"} />;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t14 || $[30] !== t16) {
    t17 = <InputDecorator label={"\uC774\uBA54\uC77C"} validationMessage={t14}>{t16}</InputDecorator>;
    $[29] = t14;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = errors.birthDate?.message;
  let t19;
  if ($[32] !== register) {
    t19 = register("birthDate");
    $[32] = register;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== getValues) {
    t20 = getValues("birthDate");
    $[34] = getValues;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  const t21 = !!t20;
  let t22;
  if ($[36] !== t19 || $[37] !== t21) {
    t22 = <Input {...t19} disabled={t21} placeholder={"YYYYMMDD \uD615\uC2DD\uC73C\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694"} type="text-date" />;
    $[36] = t19;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t18 || $[40] !== t22) {
    t23 = <InputDecorator label={"\uC0DD\uB144\uC6D4\uC77C"} validationMessage={t18}>{t22}</InputDecorator>;
    $[39] = t18;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  const t24 = errors.codeGender?.message;
  const t25 = watch("codeGender") === "C02-01" ? "primary-fill" : "primary-line";
  let t26;
  if ($[42] !== setValue) {
    t26 = () => setValue("codeGender", "C02-01");
    $[42] = setValue;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t25 || $[45] !== t26) {
    t27 = <Button className="flex-1" dimensions="H40" theme={t25} onClick={t26}>남성</Button>;
    $[44] = t25;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  const t28 = watch("codeGender") === "C02-02" ? "primary-fill" : "primary-line";
  let t29;
  if ($[47] !== setValue) {
    t29 = () => setValue("codeGender", "C02-02");
    $[47] = setValue;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== t28 || $[50] !== t29) {
    t30 = <Button className="flex-1" dimensions="H40" theme={t28} onClick={t29}>여성</Button>;
    $[49] = t28;
    $[50] = t29;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t27 || $[53] !== t30) {
    t31 = <div className="flex w-full items-center gap-8">{t27}{t30}</div>;
    $[52] = t27;
    $[53] = t30;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== t24 || $[56] !== t31) {
    t32 = <InputDecorator label={"\uC131\uBCC4"} validationMessage={t24}>{t31}</InputDecorator>;
    $[55] = t24;
    $[56] = t31;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] !== putProfileMutate) {
    t33 = t34 => {
      const {
        email,
        nickname,
        codeGender: code_gender
      } = t34;
      putProfileMutate({
        body: {
          email,
          nickname,
          codeGender: code_gender
        }
      });
    };
    $[58] = putProfileMutate;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== handleSubmit || $[61] !== t33) {
    t34 = handleSubmit(t33);
    $[60] = handleSubmit;
    $[61] = t33;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== isPending || $[64] !== t34) {
    t35 = <Button className="w-full" dimensions="H40" loading={isPending} onClick={t34}>변경 사항 저장</Button>;
    $[63] = isPending;
    $[64] = t34;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] !== logout) {
    t36 = <Button className="w-full" dimensions="H40" theme="primary-text" onClick={() => {
      logout({
        redirect: ROUTES.HOME.pathname,
        toastOptions: {
          message: "\uB85C\uADF8\uC544\uC6C3 \uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
          type: "success"
        }
      });
    }}>로그아웃</Button>;
    $[66] = logout;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== t35 || $[69] !== t36) {
    t37 = <div className="flex flex-col gap-8 pt-8">{t35}{t36}</div>;
    $[68] = t35;
    $[69] = t36;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== t13 || $[72] !== t17 || $[73] !== t23 || $[74] !== t32 || $[75] !== t37 || $[76] !== t6) {
    t38 = <div className="flex flex-col gap-12 p-20 pt-16 duration-300 animate-in fade-in">{t6}{t13}{t17}{t23}{t32}{t37}</div>;
    $[71] = t13;
    $[72] = t17;
    $[73] = t23;
    $[74] = t32;
    $[75] = t37;
    $[76] = t6;
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  return t38;
};
function _temp(state) {
  return state.myInfo;
}